import { InfoCircledIcon } from "@radix-ui/react-icons"
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"

interface MoreInfoButtonProps {
  children: React.ReactNode;
}

export function MoreInfoButton({ children }: MoreInfoButtonProps) {
  return (
    <HoverCard>
      <HoverCardTrigger>
        <InfoCircledIcon />
      </HoverCardTrigger>
      <HoverCardContent className="shadow-lg">{children}</HoverCardContent>
    </HoverCard>
  )
}
